exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?minimize!./ui-popup.css"), "");

// module
exports.push([module.id, ".ui-notice{padding:10px;border:1px solid #000;border-radius:5px;background:rgba(0,0,0,.7);color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./src/css/ui-notice.css
// module id = 9
// module chunks = 0